import { render, staticRenderFns } from "./LiabilitiesManagementView.vue?vue&type=template&id=df2b35c6&"
import script from "./LiabilitiesManagementView.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports